export default "__VITE_ASSET__4e859a70__"